import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import DocumentoModale from "../gestioneDocumenti/Aggiungi&Modifica";
import { Add } from "@mui/icons-material";
import { chiaveDocumento, useFormAccordo } from "./ContextAccordo";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfermaElimina from "./lib/ConfermaElimina";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Documenti = () => {
  const { formState, dispatch } = useFormAccordo();
  // Le righe sono i documenti del context: arrivano da accordiGetDetails e
  // vengono inviati all'API con il salvataggio globale dell'accordo
  const rows = formState.documenti || [];

  const [pageSize, setPageSize] = useState(5);
  const [openModale, setOpenModale] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // Chiave del documento aperto nella modale ("" = nuovo documento)
  const [iduid, setIduid] = useState("");

  // "Applica" della modale: salva il documento solo in locale
  const applicaDocumento = (documento) => {
    dispatch({
      type: "set_documenti",
      id: chiaveDocumento(documento),
      payload: documento,
    });
  };

  const handleOpenModale = (iduid) => {
    setIduid(iduid);
    setOpenModale(true);
  };

  const openDeleteDialog = (iduid) => {
    setIduid(iduid);
    setOpenDeleteModal(true);
  };

  const deleteDocumento = () => {
    dispatch({
      type: "delete_documenti",
      id: iduid,
    });
    setOpenDeleteModal(false);
  };

  const columns = [
    {
      field: "nome",
      headerName: "Nome",
      minWidth: 300,
      flex: 1,
      renderCell: (params) => (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box>
              <IconButton
                onClick={() => openDeleteDialog(chiaveDocumento(params.row))}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Box>
            <Typography
              fontWeight="bold"
              color="#407ad6"
              sx={{
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => handleOpenModale(chiaveDocumento(params.row))}
            >
              {params.row.nome}
            </Typography>

            <Typography fontSize={10}>{params.row.descrizione}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "tipo",
      headerName: "Tipo",
      minWidth: 200,
      flex: 1,
      headerAlign: "start",
      align: "start",
    },
    {
      field: "fonte",
      headerName: "Fonte",
      minWidth: 200,
      flex: 1,
      headerAlign: "start",
      align: "start",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">{params.row.fonte}</Typography>
            {params.row.idFonte === 3 ? (
              <Typography fontSize={10}>{params.row.idUidFile}</Typography>
            ) : params.row.idFonte === 2 ? (
              <Typography fontSize={10}>{params.row.link}</Typography>
            ) : (
              <></>
            )}
            <Typography fontSize={12}>{params.row.valoreFonte}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "abilitato",
      headerName: "Abilitato",
      headerAlign: "start",
      align: "center",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <Switch
          id={`abilitato/${params.id}`}
          name={`abilitato/${params.id}`}
          checked={params.row.abilitato === 1}
          onChange={(e) => {
            dispatch({
              type: "set_documenti",
              id: chiaveDocumento(params.row),
              payload: { abilitato: e.target.checked ? 1 : 0 },
            });
          }}
          sx={{
            "&.MuiSwitch-root .MuiSwitch-switchBase": {
              color: "#ccc",
            },
            "&.MuiSwitch-root .Mui-checked": {
              color: "#407ad6",
            },
          }}
        />
      ),
    },
    {
      field: "tipoObbligatorio",
      headerName: "Tipo Obbligatorio",
      headerAlign: "start",
      align: "start",
      minWidth: 250,
      flex: 1,
    },
  ];

  return (
    <>
      {openModale && (
        <DocumentoModale
          open={openModale}
          setOpen={setOpenModale}
          iduid={iduid}
          documentoLocale={
            rows.find((row) => chiaveDocumento(row) === iduid) ?? null
          }
          opzioni={formState.options}
          defaultOpzioni={formState.optionDefaults}
          idTipologia={formState.accordo.idTipologia}
          onApplica={applicaDocumento}
        />
      )}
      {openDeleteModal && (
        <ConfermaElimina
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          onConfirm={deleteDocumento}
          type="documento"
        />
      )}
      <Box display="flex" justifyContent="end" gap={4}>
        <Button
          mr={2}
          variant="contained"
          color="primary"
          onClick={() => handleOpenModale("")}
        >
          <Add />
        </Button>
      </Box>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h6" gutterBottom>
            Risultati: {rows.length}
          </Typography>
        </Grid>
      </Grid>

      <Paper sx={{ width: "100%" }} mt={4}>
        <DataGrid
          columns={columns}
          rows={rows}
          getRowId={chiaveDocumento}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
          autoHeight
          disableSelectionOnClick
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No rows in DataGrid
              </Stack>
            ),
          }}
        />
      </Paper>
    </>
  );
};

export default Documenti;
